<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="notifications-reports"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :date="date"
      :externalFilters="externalFilters"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">Уведомления</h1>
        <btn-filters
          :data="data"
          endpoint="users"
          v-model="filtersValue"
          :range="true"
          :date.sync="date"
        ></btn-filters>
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
        @filter-change="refreshFilters"
      >
        <table-column-serial-number machine-prop="machine"/>
        <el-table-column prop="" label="Пользователь" min-width="300">
          <template slot-scope="{row:{user}}">{{user | fullName}}</template>
        </el-table-column>
        <el-table-column label="Тип" min-width="120">
          <template slot-scope="{row}">
            <img v-if="row.email" src="../../../img/type.svg" alt="">
            <img v-if="row.sms" src="../../../img/phone.svg" alt="">
          </template>
        </el-table-column>
        <el-table-column
          prop="text"
          label="Текст уведомления"
          min-width="400"
          :filters="codeFilters"
          filter-placement="bottom-start"/>
        <table-column-date label="Уведомление создано" :width="220"/>
        <el-table-column label="Email отправлен" :width="220">
          <template slot-scope="{row}">
            <span v-if="!row.email">–</span>
            <span v-else-if="row.email_delivery_state === 'submitted' && row.email_sent_at"
                  title="Письмо принято почтовым сервером; получение адресатом не подтверждено">
              {{row.email_sent_at | formatDate}}
            </span>
            <span v-else-if="row.email_delivery_state === 'pending'">В процессе</span>
            <span v-else-if="row.email_delivery_state === 'failed' || row.email_delivery_state === 'skipped'"
                  title="Письмо не отправлено: ошибка либо получатель или подписка изменены">Ошибка</span>
            <span v-else title="Для старых записей время отправки не фиксировалось">Нет данных</span>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import sortBy from 'lodash/sortBy'
  import events from '../../lang/events.json'

  export default {
    metaInfo: {title: 'Уведомления'},
    data () {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        hasMore: true,
        date: {
          min: null,
          max: null,
        },
        externalFilters: null,
      }
    },
    methods: {
      refreshFilters (event) {
        this.externalFilters = Object.values(event)
      },
    },
    computed: {
      codeFilters () {
        return sortBy(Object.entries(events).map(([key, value]) => {
          return {
            value: key,
            text: value.split('|')[0],
          }
        }), 'text')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/reports/notifications.vue